export default {
	packageData: (state) => state.package,
	packageProducts: (state) => state.package?.products ? state.package.products : [],
}
